import axios from "axios";
import { API } from "../config";

export const getProdutDetail = async (productID) => {
    const data = await axios.get(API.PRODUCT_DETAIL + `?id=${productID}`);

    return data.data;
};
